import { render, staticRenderFns } from "./SupplierInvoicePayment.vue?vue&type=template&id=756f96ce"
import script from "./SupplierInvoicePayment.vue?vue&type=script&lang=js"
export * from "./SupplierInvoicePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports